export const ROUTE_PATH_ADMIN = '/admin';
